import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useMemo } from 'react';

export type TFieldSaveState = 'saving' | 'saved';

interface IProps {
  state?: TFieldSaveState;
  right: number;
}

const REGION_SX = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'flex',
  alignItems: 'center',
  pointerEvents: 'none',
  zIndex: 1,
} as const;

const VISIBLE_SX = { pl: 0.5, bgcolor: 'background.paper' } as const;

export const FieldSaveIndicator: React.FC<IProps> = ({ state, right }) => {
  const sx = useMemo(() => ({ ...REGION_SX, right, ...(state ? VISIBLE_SX : {}) }), [right, state]);

  return (
    <Box role="status" aria-live="polite" sx={sx}>
      {state === 'saving' && <CircularProgress size={16} aria-label="Saving" />}
      {state === 'saved' && (
        <Typography variant="body2" sx={{ color: 'success.main' }}>
          Saved
        </Typography>
      )}
    </Box>
  );
};

export default FieldSaveIndicator;
